/** Base Fetch Actions */
export const FETCH_ALL_ORGANIZATIONS_REQUEST = `FETCH_ALL_ORGANIZATIONS_REQUEST` as const;
export const FETCH_ALL_ORGANIZATIONS_RESPONSE = `FETCH_ALL_ORGANIZATIONS_RESPONSE` as const;

/** Fetch Organization Users Actions */
export const FETCH_ORGANIZATION_USERS_REQUEST = `FETCH_ORGANIZATION_USERS_REQUEST` as const;
export const FETCH_ORGANIZATION_USERS_RESPONSE = `FETCH_ORGANIZATION_USERS_RESPONSE` as const;

/** Update Organization Actions */
export const UPDATE_ORGANIZATION_REQUEST = `UPDATE_ORGANIZATION_REQUEST` as const;
export const UPDATE_ORGANIZATION_RESPONSE = `UPDATE_ORGANIZATION_RESPONSE` as const;

/** Fetch Hightouch Allotment Sync Limit Actions */
export const FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST =
  `FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST` as const;
export const FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE =
  `FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE` as const;

/** Update Hightouch Allotment Sync Limit Actions */
export const UPDATE_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST =
  `UPDATE_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST` as const;
export const UPDATE_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE =
  `UPDATE_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE` as const;
